const api = `${process.env.REACT_APP_API_URL}/`;
const download = `${process.env.REACT_APP_DOWNLOAD_URL}/${process.env.REACT_APP_DOWNLOAD_FOLDER}/`;

export const API = api;
export const DOWNLOAD = download;